if (!window.Pusher) window.Pusher = require('pusher-js')

const setPusher = () => {
  window.ppdPusher = new window.Pusher(window.ppd.Pusher.key)
}

window.ppdPusher || setPusher()

export default window.ppdPusher
